<div class="flex-direction-column height-100 page">
  <div class="flex-direction-row justify-between align-center">
    @if (variaveis.length > 0) {
      <app-form-field style="margin-right: 1%" placeholder="Pesquisar" iconPrefix="search" iconColor="var(--primary)" backgroundColor="transparent" classe="pesquisar"
                      widthFormField="325px" heightFormField="35px" borderColor="var(--primary)" (changeValue)="filtrarVariaveis($event)"></app-form-field>
    }
  </div>

  @if (variaveis.length > 0) {
    <mat-table [dataSource]="variaveisDataSource">
      <ng-container matColumnDef="acao">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <div class="flex-direction-row gap-5">
            <app-button-padrao iconSrc="icones/edit" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
                               widthIcon="22px" heightIcon="22px" (buttonClick)="abrirModal(false, elemento)"></app-button-padrao>
            <app-button-padrao iconSrc="icones/visualizar" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
                               widthIcon="20px" heightIcon="20px" (buttonClick)="abrirModal(true, elemento)"></app-button-padrao>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nome">
        <mat-header-cell *matHeaderCellDef>Nome</mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="center-start" matTooltip="{{ elemento?.nome || '' }}">
          <p class="ellipse">{{ elemento.nome || '-'}}</p>
         </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tipo">
        <mat-header-cell *matHeaderCellDef>Tipo</mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="center-start"> {{ getLabel(elemento.tipo) }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef>Status </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento.ativo ? 'Ativo' : 'Inativo' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="isPesquisa">
        <mat-header-cell *matHeaderCellDef>Pesquisa? </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento.isPesquisa ? 'Sim' : 'Não' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuCriacao">
        <mat-header-cell *matHeaderCellDef>
          <p>Usuário Criação</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="center-start" matTooltip="{{ elemento?.usuarioCriacao?.nome || '' }}">
          <p class="ellipse">{{ elemento.usuarioCriacao?.nome ?? '--' }} </p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataCriacao">
        <mat-header-cell *matHeaderCellDef>Data Criação</mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento.dataCriacao | date: 'dd/MM/yyyy HH:mm' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuAlteracao">
        <mat-header-cell *matHeaderCellDef>
          <p>Usuário Alteração</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="center-start" matTooltip="{{ elemento?.usuarioAlteracao?.nome || '' }}">
          <p class="ellipse">{{ elemento.usuarioAlteracao?.nome ?? '-' }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataAlteracao">
        <mat-header-cell *matHeaderCellDef>Data Alteração</mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento.dataAlteracao ? (elemento.dataAlteracao | date: 'dd/MM/yyyy HH:mm') : '' }} </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  }
  @else if (variaveisCarregadas){
    <div class="flex center-center height-100">
      <img style="height: 394px; width: 582px;" src="./assets/imagem-mulher-nao-eh-bug.png" alt="">
    </div>
  }

  <img src="./assets/botao-add.svg" class="botao-add cursor-pointer" alt="Adicionar variável" role="button" tabindex="0" (click)="abrirModal(false)" (keydown.enter)="abrirModal(false)" />
</div>
